import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Sisselogimine Google kontoga ebaõnnestus. Proovi uuesti või korduva ebaõnnestumise korral võta ühendust klienditeenindusega.

  <span style="color:#85c1dc;">**FI:**</span>
  Kirjautuminen Googlella epäonnistui. Yritä uudelleen tai ota yhteyttä asiakaspalveluun toistuvien epäonnistumisten yhteydessä.

  <span style="color:#85c1dc;">**RU:**</span>
  Вход через Google не удался. Попробуйте снова или, в случае повторной неудачи, свяжитесь со службой поддержки.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1639 = msg(
  mf`Sisselogimine Google kontoga ebaõnnestus. Proovi uuesti või korduva ebaõnnestumise korral võta ühendust klienditeenindusega.`,
  mf`Kirjautuminen Googlella epäonnistui. Yritä uudelleen tai ota yhteyttä asiakaspalveluun toistuvien epäonnistumisten yhteydessä.`,
  mf`Вход через Google не удался. Попробуйте снова или, в случае повторной неудачи, свяжитесь со службой поддержки.`,
)

export { m1639 as 'w.login.google.error.generic_login' }